module.exports = __webpack_public_path__ + "img/weather.c989c3ed.png";